import { defineStore } from 'pinia'

export const useDomainStore = defineStore({
  id: 'page',
  state: () => ({
    domain: localStorage.getItem('lastSearchDomain') || 'mail1.tobi.com',
    inboxPlacementDomain: localStorage.getItem('inboxPlacementDomain') || 'hdfcbank.net',
    startDate: new Date(new Date()).setDate(new Date().getDate() + -30),
    endDate: new Date(),
    theme: localStorage.getItem('theme') || 'light',
    page: 'Dashboard',
    relivancy: 0,
    accountPagePath: null,
  }),
  actions: {
    updateDomain(value) {
      this.domain = value
    },
    updateInboxPlacementDomain(value) {
      this.inboxPlacementDomain = value
    },
    updateDate(start, end) {
      this.startDate = start
      this.endDate = end
    },
    datePlusDay(date, days) {
      const d = new Date(date)
      d.setDate(d.getDate() + days)
      return d
    },
    initializeDates() {
      this.startDate = this.datePlusDay(new Date(), -30)
    },
    setTheme(value) {
      localStorage.setItem('theme', value)
      this.theme = localStorage.getItem('theme')
    },
    updatePage(value) {
      this.page = value
    },
    setRelivancy(value) {
      this.relivancy = value
    },
    setAccountPage(value) {
      this.accountPagePath = value
    },
  },
  getters: {
    formattedStartDate: (state) => (state.startDate ? state.startDate.toISOString().split('T')[0] : null),
    formattedEndDate: (state) => (state.endDate ? state.endDate.toISOString().split('T')[0] : null),
  },
})

// Initialize dates when the store is created
// const domainStore = useDomainStore()
// domainStore.initializeDates()
